<script setup lang="ts">
import GiftlyLogo from './Header/GiftlyLogo.vue'
import MainContainer from './Header/MainContainer.vue'
import UserMenu from './Header/UserMenu.vue'

// Minimal header for logged-out event pages: Giftly logo + "Event invitation"
// label + account/menu, only. No search, cart, favorites, or category nav. A
// single fixed row of a consistent height (matches MainContainer), so a
// collapsing event header below it pins at a stable offset.
defineEmits(['close'])
</script>

<template>
  <div class="fixed top-0 w-full z-navbar bg-white">
    <V2Container class="!p-0 w-full">
      <MainContainer>
        <div class="flex items-center gap-3">
          <GiftlyLogo/>
          <span class="text-sm font-medium text-v2-tertiary">Event invitation</span>
        </div>
        <UserMenu/>
      </MainContainer>
    </V2Container>
  </div>

  <!-- Reserves the fixed bar's height (matches MainContainer). -->
  <div class="h-[58px] lg:h-[84px]"/>
</template>
